import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Chip,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import yellowt from "@/assets/yellow-t.png";
import upcomingImg from "@/assets/logo.png";
import cool from "@/assets/cool.svg";
import Countdown from "react-countdown";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { he } from "date-fns/locale";


export const UpcomingLottery = ({ data }) => {
  const navigate = useNavigate();
  console.log(data, "datamds,d,sm");
  var content = {
    color: "#ffff",
    backgroundColor: "#3C37FF",
    borderRadius: "10px",
    height: "350px",
  };
  var center = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  var button = {
    background: "rgba(255, 255, 255, 0.13)",
    borderRadius: "15.507px",
    color: "#FFFFFF",
  };
  return (
    <>
      {data?.length > 0 ? (
        <>
          <Typography
            component="h4"
            variant="h4"
            sx={{
              marginBottom: { xs: "10px", md: "20px", lg: "20px" },
              marginTop: { xs: "15px", md: "30px", lg: "30px" },
              fontSize: { xs: "16px", md: "20px", lg: "24px" },
            }}
          >
            Upcoming Lottery
          </Typography>
          <Box
            sx={{
              backgroundColor: "rgba(5, 5, 24, 0.8)",
              borderRadius: "10px",
              padding: { xs: "10px", md: "20px", lg: "30px" },
              
            }}
          >
            <Grid container display={"flex"} direction={"column"}>
              <Grid item xs={8} sm={8} md={8} lg={6}>
                <Grid
                  container
                  display={"flex"}
                  direction={"row"}
                  spacing={2}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  {data?.map((value, index) => (
                    <Grid
                      item
                      key={index}
                      xs={6}
                      sm={3}
                      lg={2.4}
                      className="inner-grid"
                    >
                      <Card
                        style={content}
                        sx={{
                          position: "relative",
                          margin: "0 auto",
                          "&:hover": {
                            backgroundColor: "#fff !important",
                            color: "black !important",
                            boxShadow: 20,
                            cursor: "pointer",
                            minHeight: "182px",
                            backgroundPosition: "50% 0%",
                            backgroundRepeat: "no-repeat",
                            display: "block",
                            /* width: 100%; */
                            backgroundSize: "cover",
                            "& div div .MuiDivider-root": {
                              borderBottomColor: "black !important", // Change the color of the Divider component
                            },
                            "& div h5": {
                              backgroundColor: "#fff !important",
                              color: "black !important",
                            },
                            "& div div .MuiCardContent-root": {
                              backgroundColor: "#fff !important",
                              color: "black !important",
                            },
                            "& div div div div.MuiPaper-root": {
                              border: "1.23px solid #00000038 !important",
                              background: "#fff",
                              boxShadow: "none",
                            },
                            "& div button": {
                              background: "#3C37FF",
                              borderRadius: "15.507px",
                              color: "#FFFFFF !important",
                            },
                          },
                        }}

                      >
                        {/* <Chip
                          label={`${value?.numOfTicketSold || 0}  Sold`}
                          sx={{
                            position: "absolute",
                            transform: "rotate(45deg)",
                            top: "2px",
                            right: "-31px",
                            backgroundColor: "#fff",
                            color: "Red",
                            borderRadius: "4px",
                            padding: "4px 17px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            zIndex: 1,
                          }}
                        /> */}

                        <CardMedia
                          className="img-card"
                          sx={{
                            height: 156,
                            backgroundPosition: "center",
                            backgroundSize: "100% 100%",
                            backgroundColor: "#000",
                          }}
                          image={
                            value.image
                              ? `${process.env.API_URL_PREFIX}/api/v1/admin/uploads/${value.image}`
                              : upcomingImg
                          }
                          title="green iguana"
                        />
                        <CardContent
                          style={center}

                          sx={{
                            flexDirection: "column",
                            pb: "0px",
                            cursor: "pointer",
                            height: "80px",
                            mt: "42px",
                          }}
                        >
                          <Typography component="h5" variant="h5" gutterBottom>
                            {value.lotteryName}

                          </Typography>
                          <Typography
                            component="h5"
                            variant="h5"
                            gutterBottom
                            sx={{ display: "flex" }}
                          >
                            <img
                              style={{
                                height: "auto",
                                width: "15px",
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                              alt="yellow-t"
                              loading="lazy"
                              src={yellowt}
                            />{" "}
                            {value.ticketPrice}
                          </Typography>
                          <Typography
                            component="h5"
                            variant="h5"
                            gutterBottom
                            sx={{ fontSize: "16px", display: "flex" }}
                          >
                            <Countdown
                              date={moment(
                                `${value?.endDate.split(" ")[0]} ${value?.endTime
                                }`,
                                "YYYY-MM-DD hh:mm A"
                              ).toDate()}
                            />
                          </Typography>

                          <Button
                            onClick={() => {

                              navigate("/auth/login", { state: { from: { pathname: `/app/Lotteries/${value._id}` } } });
                            }}
                            sx={{
                              px: "3px",
                              py: "3.73px",
                              marginBottom: "10px !important",
                              background: "rgba(255, 255, 255, 0.5)",
                              borderRadius: "15.507px",
                              color: "#3C37FF !important",
                              width: "115px !important",
                              textAlign: "center",
                              fontWeight: "600",
                              "&:hover": {
                                background: "rgba(1, 1, 1, 0.5)",
                              },
                            }}
                          >
                            Buy Ticket
                          </Button>
                          <Typography
                            component="h5"
                            variant="h5"
                            gutterBottom
                            sx={{
                              fontSize: "12px !important",
                              display: "flex",
                              textAlign: "center",
                              mb: "5px",
                            }}
                          >
                            {moment(
                              `${value?.endDate} ${value?.endTime}`,
                              "YYYY-MM-DD HH:mm:ss A"
                            ).format("DD-MM-YYYY")}
                            {"            "}
                            {value?.endTime}
                          </Typography>
                          <Typography
                            component="h5"
                            variant="h5"
                            gutterBottom
                            sx={{
                              fontSize: "12px !important",
                              display: "flex",
                              textAlign: "center",
                              mb: "5px",
                            }}
                          >
                            {/* Display formatted endTime */}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default UpcomingLottery;
